import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CompanyEffects } from './+state/company.effects';
import { CompanyFacade } from './+state/company.facade';
import * as fromCompany from './+state/company.reducer';
import { CompanyNgrxService } from './company.service';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forRoot({}),
        StoreModule.forFeature(fromCompany.COMPANY_NGRX_FEATURE_KEY, fromCompany.companyNgrxReducer)
    ],
    providers: [CompanyNgrxService, CompanyFacade, CompanyEffects]
})

export class CompanyNgrxModule {}
